import React from 'react';

import dayjs from 'dayjs';

import { isDateType, isNumericType } from './dataType';

/**
 * 테이블 셀 값 렌더링 유틸리티
 */

/**
 * 숫자 값 포맷팅
 */
export const formatNumericValue = (value: number): string => {
  if (Number.isInteger(value)) {
    return value.toLocaleString();
  }
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });
};

/**
 * 날짜/시간 값 포맷팅
 */
export const formatDateValue = (value: string): string | null => {
  const date = dayjs(value);
  if (date.isValid()) {
    return date.format('YYYY-MM-DD HH:mm:ss');
  }
  return null;
};

/**
 * 테이블 셀 값 렌더링
 */
export const renderCellValue = (value: unknown, dataType?: string): React.ReactNode => {
  // NULL 값 처리
  if (value === null || value === undefined) {
    return <span style={{ color: 'var(--opds-glo-palette-gray-50)', fontStyle: 'italic' }}>NULL</span>;
  }

  const stringValue = String(value);

  if (isNumericType(dataType)) {
    const numValue = Number(stringValue);
    if (!isNaN(numValue)) {
      return formatNumericValue(numValue);
    }
  }

  if (isDateType(dataType)) {
    const formattedDate = formatDateValue(stringValue);
    if (formattedDate) {
      return formattedDate;
    }
  }

  return stringValue;
};
